import React, { useEffect, useState } from 'react';
import { FolderIcon, FolderOpenIcon } from 'lucide-react';
import { childrenOf, isFolder, isWithin } from '../../utils/fileTree';
import type { FsNode } from '../../types/files';
interface MoveDialogProps {
  nodes: FsNode[];
  movingIds: string[];
  onCancel: () => void;
  onConfirm: (targetId: string | null) => void;
}
export function MoveDialog({
  nodes,
  movingIds,
  onCancel,
  onConfirm
}: MoveDialogProps) {
  const [targetId, setTargetId] = useState<string | null>(null);
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onCancel]);
  const isBlocked = (folderId: string) => movingIds.includes(folderId) || movingIds.some(id => isWithin(nodes, folderId, id));
  const renderLevel = (parentId: string | null, depth: number) => childrenOf(nodes, parentId).filter(isFolder).map(folder => {
    const blocked = isBlocked(folder.id);
    return <li key={folder.id} data-id="element-191" data-mp="1re5i2lr0elca">
            <button type="button" disabled={blocked} onClick={() => setTargetId(folder.id)} style={{
        paddingLeft: `${12 + depth * 16}px`
      }} className={['flex w-full items-center gap-2 py-1.5 pr-3 text-left text-sm transition focus:outline-none', blocked ? 'cursor-not-allowed text-slate-300' : targetId === folder.id ? 'bg-[#eef4ff] font-semibold text-[#014486]' : 'text-slate-700 hover:bg-slate-100'].join(' ')} data-id="element-192" data-mp="1rb12ks83g36b">
              <FolderIcon className={['h-4 w-4 shrink-0', blocked ? 'text-slate-300' : 'text-[#0176d3]'].join(' ')} aria-hidden="true" data-id="element-193" data-mp="totx7g3yu6sw" />
              <span className="truncate" data-id="element-194" data-mp="2otjvaahoe8n2">{folder.name}</span>
            </button>
            <ul data-id="element-195" data-mp="2tqjty0c74945">{renderLevel(folder.id, depth + 1)}</ul>
          </li>;
  });
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-196" data-mp="2yq6eyvy9mtni">
      <div className="absolute inset-0 bg-slate-900/40" onClick={onCancel} aria-hidden="true" data-id="element-197" data-mp="33p9czwftvzlz" />
      <div role="dialog" aria-modal="true" aria-labelledby="move-dialog-title" className="relative w-full max-w-md rounded bg-white p-5 shadow-xl" data-id="element-198" data-mp="37q2zqmhjb8da">
        <h2 id="move-dialog-title" className="text-base font-semibold text-slate-900" data-id="element-199" data-mp="3hgnu1xq6dqqe">
          Move {movingIds.length} {movingIds.length === 1 ? 'item' : 'items'}
        </h2>
        <p className="mt-1 text-sm text-slate-600" data-id="element-200" data-mp="3rfwnmph4p3c8">
          Choose the destination folder.
        </p>

        <div className="mt-3 max-h-64 overflow-y-auto rounded border border-slate-200" data-id="element-201" data-mp="3vhqigh4n7d4h">
          <ul data-id="element-202" data-mp="1jtlmeu7ozjrs">
            <li data-id="element-203" data-mp="1ju4wjor3p3v9">
              <button type="button" onClick={() => setTargetId(null)} className={['flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm transition focus:outline-none', targetId === null ? 'bg-[#eef4ff] font-semibold text-[#014486]' : 'text-slate-700 hover:bg-slate-100'].join(' ')} data-id="element-204" data-mp="1juodp38xfo88">
                <FolderOpenIcon className="h-4 w-4 shrink-0 text-[#0176d3]" aria-hidden="true" data-id="element-205" data-mp="1yhpyhfc8ox1l" />
                Loan Documents
              </button>
              <ul data-id="element-206" data-mp="1osyb7ki4j0x0">{renderLevel(null, 1)}</ul>
            </li>
          </ul>
        </div>

        <div className="mt-5 flex justify-end gap-2" data-id="element-207" data-mp="2m7kbbwwk6llu">
          <button type="button" onClick={onCancel} className="rounded border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-2" data-id="element-208" data-mp="2m9535erhnqg0">
            Cancel
          </button>
          <button type="button" onClick={() => onConfirm(targetId)} className="rounded bg-[#0176d3] px-3 py-1.5 text-sm font-semibold text-white transition hover:bg-[#014486] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-2" data-id="element-209" data-mp="1s1pw1d6uz7m5">
            Move here
          </button>
        </div>
      </div>
    </div>;
}